module.exports = __webpack_public_path__ + "img/aem.c0135fa2.svg";